import React, { useEffect, useState } from 'react'
import { Container } from 'reactstrap'
import { useParams } from 'react-router-dom';
import { IGetOrderSummaryModel } from 'models/GetOrderSummary.Model';
import { useTypedSelector } from 'features/reduxhooks/ReduxHooks';
import CommonService from 'services/CommonService';
import ImeiNumber from './ImeiNumber';
import UploadImage from './UploadImage';
import Adjustment from './Adjustment';
import SignaturePad from './SignaturePad';
import OTPVerification from './OTPVerification';
import CustomLoader from 'components/Common/CustomLoader';

function FinalDocumentVerify() {
    const { encryptedId } = useParams<any>();

    const [orderSummaryInfo, setOrderSummaryInfo] = useState<IGetOrderSummaryModel>();
    const [activeTab, setactiveTab] = useState<number>(1)
    const [passedSteps, setPassedSteps] = useState([1]);
    const [showLoading, setShowLoading] = useState(true);

    const selectedPage = useTypedSelector((state) => state.PageChangeReducer.selectedPage);
    const [route] = useState({
        IMEIPage: "IMEIPage",
        UploadImagePage: "UploadImagePage",
        Adjustment: "Adjustment",
        SignaturePad: "SignaturePad",
        OtpScreen: "OtpScreen"
    });

    const GetOrderSummary = () => {
        CommonService.getWithSingleEntity('sell', 'GetOrderSummary', encryptedId).then(res => {
            if (res.status === 200) {
                let data = res.data as IGetOrderSummaryModel;
                setOrderSummaryInfo(data);
                setShowLoading(false)
            }
        }).catch(err => console.log(err));
    }

    const navItems = [{
        id: 1,
        name: 'IMEI Number'
    }, {
        id: 2,
        name: 'Image Upload'
    }, {
        id: 3,
        name: 'Order Payout'
    }, {
        id: 4,
        name: 'Signature Pad'
    }, {
        id: 5,
        name: 'OTP Verification'
    }]

    const tabHandler = (val) => {
        console.log(val)
    }

    function toggleTab(tab: any) {
        if (activeTab !== tab) {
            var modifiedSteps = [...passedSteps, tab]
            if (tab >= 1 && tab <= 4) {
                setactiveTab(tab)
                setPassedSteps(modifiedSteps)
            }
        }
    }

    useEffect(() => {
        GetOrderSummary();
    }, [encryptedId]);
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div>
                        <h5 className="d-flex mb-3 fw-semibold text-dofy dofy-admin-font-md" style={{ whiteSpace: "pre-wrap" }}>FINAL DOCUMENTS VERIFICATION</h5>
                    </div>
                    {/* <div className="wizard clearfix">
                        <div className="steps clearfix">
                            <ul>
                                {navItems.map((item, idx) => (
                                    <NavItem
                                        className={classnames({ current: activeTab === item.id })}
                                    >

                                        <NavLink
                                            className={classnames({ current: activeTab === item.id })}
                                            onClick={() => {
                                                setactiveTab(item.id);
                                            }}
                                            disabled={true}
                                        >
                                            <span className="number">{item.id}</span>{item.name}
                                        </NavLink>
                                    </NavItem>
                                ))}


                            </ul>
                        </div>
                    </div> */}
                    <CustomLoader isOpen={showLoading} />
                    {selectedPage === route.IMEIPage && orderSummaryInfo &&
                        <ImeiNumber statusId={orderSummaryInfo?.StatusId} ProductTypeName={orderSummaryInfo?.ProductTypeName} encryptedOrderId={encryptedId} tabHandler={tabHandler} activeTab={activeTab} setActiveTab={setactiveTab} />
                    }
                    {selectedPage === route.UploadImagePage &&
                        <UploadImage statusId={orderSummaryInfo?.StatusId} ProductTypeName={orderSummaryInfo?.ProductTypeName} encryptedOrderId={encryptedId} activeTab={activeTab} setActiveTab={setactiveTab} />
                    }
                    {selectedPage === route.Adjustment &&
                        <Adjustment orderPayout={orderSummaryInfo?.Payout} referralCode={orderSummaryInfo?.ReferralCode} triggerOrderSummaryById={GetOrderSummary} activeTab={activeTab} setActiveTab={setactiveTab} />
                    }
                    {selectedPage === route.SignaturePad &&
                        <SignaturePad data={orderSummaryInfo} statusId={orderSummaryInfo?.StatusId} encryptedOrderId={encryptedId} activeTab={activeTab} setActiveTab={setactiveTab}/>
                    }
                    {selectedPage === route.OtpScreen &&
                        <OTPVerification encryptedOrderId={encryptedId} />
                    }
                    {/* <div className="content clearfix"> */}
                    {/* <TabContent activeTab={activeTab} className="body">
                        <TabPane tabId={1} >
                            <ImeiNumber orderId={decryptedId} statusId={orderSummaryInfo?.StatusId} ProductTypeName={orderSummaryInfo?.ProductTypeName} encryptedOrderId={encryptedId} tabHandler={tabHandler} activeTab={activeTab} setActiveTab={setactiveTab} />
                        </TabPane>
                        <TabPane tabId={2}>
                            <UploadImage orderId={decryptedId} statusId={orderSummaryInfo?.StatusId} ProductTypeName={orderSummaryInfo?.ProductTypeName} encryptedOrderId={encryptedId} activeTab={activeTab} setActiveTab={setactiveTab} />
                        </TabPane>
                        <TabPane tabId={3}>
                            <Adjustment orderPayout={orderSummaryInfo?.Payout} referralCode={orderSummaryInfo?.ReferralCode} triggerOrderSummaryById={GetOrderSummary} activeTab={activeTab} setActiveTab={setactiveTab} />
                        </TabPane>
                        < TabPane tabId={4}>
                            <SignaturePad orderId={decryptedId} data={orderSummaryInfo} statusId={orderSummaryInfo?.StatusId} encryptedOrderId={encryptedId} activeTab={activeTab} setActiveTab={setactiveTab} load={rendered} />
                        </TabPane>
                        < TabPane tabId={5}>
                            <OTPVerification encryptedOrderId={encryptedId} decryptedOrderId={decryptedId} />
                        </TabPane>
                    </TabContent> */}
                    {/* </div> */}

                </Container>
            </div>
        </React.Fragment >
    )
}

export default FinalDocumentVerify
